export default function unwrapError(error) {
  if (!error) return undefined;
  return {
    ...error,
    message: error.message,
    stack: error.stack,
    innerError: unwrapError(error.innerError),
  };
}
